import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useQuery } from 'urql';
import cc from 'classcat';
import PropTypes from 'prop-types';
import Spinner from '../../../components/icons/Spinner';
import { Category } from './Category';
import { ERROR_MESSAGE } from './constants';
import { searchArticles } from './queries';
import categoryCSS from './Category.module.scss';
import css from './SearchResults.module.scss';
import QuickActions from './QuickActions';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var SearchResults = function SearchResults(_ref) {
  var term = _ref.term;

  var _useQuery = useQuery({
    query: searchArticles,
    variables: {
      search: term
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching,
      error = _useQuery2$.error;

  if (error) {
    console.error(error);
    return /*#__PURE__*/_jsx(_Fragment, {
      children: ERROR_MESSAGE
    });
  }

  var articles = fetching ? [] : data.faqsArticles;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [fetching && /*#__PURE__*/_jsxs("div", {
      "aria-busy": "true",
      children: [/*#__PURE__*/_jsx("h2", {
        className: categoryCSS.title,
        children: "Searching"
      }), /*#__PURE__*/_jsx(Spinner, {})]
    }), !fetching && articles.length === 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("h2", {
        className: categoryCSS.title,
        children: "Out Of Bounds"
      }), /*#__PURE__*/_jsx("p", {
        className: css.copy,
        children: "We\u2019re sorry, but we can\u2019t find anything for that search."
      }), /*#__PURE__*/_jsx(QuickActions, {})]
    }), !fetching && articles.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("h2", {
        className: cc([categoryCSS.title, css.title]),
        children: [data.faqsArticles.length, " result", data.faqsArticles.length === 1 ? '' : 's', " for \u201C", term, "\u201D"]
      }), /*#__PURE__*/_jsx(Category, {
        articles: data.faqsArticles,
        searchResults: true
      })]
    })]
  });
};

SearchResults.propTypes = {
  term: PropTypes.string
};
export default SearchResults;